module.exports = __webpack_public_path__ + "static/img/team-manager-icon.1d68ddfc.png";